module.exports = require("./mni-Beng");